/**
 * 未登录时拉起登录弹窗，并让收藏请求在进接口前中断。
 * 调用方用 isLoginRequiredError 区分「需要登录」和真实失败，避免再提示收藏失败。
 */
import { useLoginStore } from "@/store/login";
import { useUserStore } from "@/store/user";

export class LoginRequiredError extends Error {
  readonly loginRequired = true;

  constructor() {
    super("需要登录");
    this.name = "LoginRequiredError";
  }
}

export function isLoginRequiredError(error: unknown): boolean {
  return error instanceof LoginRequiredError;
}

/** 已登录返回 true。未登录拉起登录弹窗并返回 false。 */
export function ensureLogin(loginPosition?: string): boolean {
  const userStore = useUserStore();
  if (userStore.isLogin) return true;

  const loginStore = useLoginStore();
  if (loginPosition) {
    loginStore.loginPopUpParams.login_position = loginPosition;
  }
  void loginStore.handleDeviceEnv();
  return false;
}

export function rejectIfNotLogin(loginPosition?: string): Promise<never> | undefined {
  if (ensureLogin(loginPosition)) return undefined;
  return Promise.reject(new LoginRequiredError());
}
